import React from "react";
import TaskItem, { TaskDetail } from "./TaskItem";
import { BaseTask } from "model/activitiesModel";
import { Monitor } from "hooks/useMonitor";
import { Priority } from "hooks/usePriorities";

export interface StartedProcess extends TaskDetail {
  jsontag: string | null;
  jsongroups: string | null;
  jsonroles: string | null;
  priorityname: string | null;
  idprocess: number;
  process_description: string;
  process_enddate: string | null;
  process_startdate: string | null;
  process_idprocessmodel: number;
  process_userdata: string;
  processduration: number;
  priorityorder: number | null;
}

interface ProcessItemProps {
  handleClick: (task: TaskDetail, type: "delete" | "terminate" | "disclose" | "reschedule") => void;
  process: StartedProcess;
  filters: Record<string, any>;
  setSelectedTask: (task: BaseTask) => void;
  userDataKeys: string[];
  monitors: Monitor[];
  isMonitorsLoading: boolean;
  // expandedCells: Record<string, boolean>;
  // toggleExpand: (key: string, e: React.MouseEvent) => void;
  openFullContentDialog: (content: string, title: string) => void;
  refresh: () => void;
  allPriorities: Priority[];
  loadingPriorities: boolean;
}
const ProcessItem: React.FC<ProcessItemProps> = React.memo(({
  handleClick,
  setSelectedTask,
  process,
  filters,
  monitors,
  userDataKeys,
  isMonitorsLoading,
  // expandedCells,
  // toggleExpand,
  openFullContentDialog,
  refresh,
  allPriorities,
  loadingPriorities,
}) => {
  return (
    <React.Fragment>
      <TaskItem
        setSelectedTask={setSelectedTask}
        handleClick={handleClick}
        key={`task-in-processes-${process.idprocesstoken}`}
        process={process}
        monitors={monitors}
        filters={filters}
        isMonitorsLoading={isMonitorsLoading}
        task={process}
        userDataKeys={userDataKeys}
        refresh={refresh}
        //  expandedCells={expandedCells}
        //  toggleExpand={toggleExpand}
        openFullContentDialog={openFullContentDialog}
        allPriorities={allPriorities}
        loadingPriorities={loadingPriorities}
      />
    </React.Fragment>
  );
});

export default ProcessItem;
